<template>
  <AIVDialog
    :visible="visible"
    :title="title"
    width="460px"
    height="auto"
    @update:visible="onDialogVisibility"
  >
    <div class="nudge-body">
      <div class="nudge-icon">
        <i class="fa-solid fa-mobile-screen-button"></i>
      </div>
      <p class="nudge-lead">
        {{ actionWord }} works best in the <strong>Oppo mobile app</strong>.
      </p>
      <p class="nudge-sub">
        The app uses your phone's location for accurate geofencing and syncs more
        reliably than the web. Please {{ actionWord.toLowerCase() }} from the app
        when you can.
      </p>

      <div class="nudge-store-links">
        <a
          :href="iosUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="nudge-store-link"
        >
          <i class="fa-brands fa-apple"></i> Download on the App Store
        </a>
        <a
          :href="androidUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="nudge-store-link"
        >
          <i class="fa-brands fa-google-play"></i> Get it on Google Play
        </a>
      </div>
    </div>

    <template slot="footer">
      <div class="nudge-footer">
        <el-button type="primary" round @click="handleDownload">
          <i class="fa-solid fa-download"></i> Download the app
        </el-button>
        <el-button round @click="handleContinue">
          Continue in web
        </el-button>
      </div>
    </template>
  </AIVDialog>
</template>

<script>
import AIVDialog from "@/components/AIVDialog.vue";
import { clockNudgeConfig } from "@/config/clockNudge";

export default {
  name: "WebClockNudgeModal",
  components: { AIVDialog },
  props: {
    visible: { type: Boolean, default: false },
    // "in" or "out" — controls the wording only.
    mode: { type: String, default: "in" },
  },
  data() {
    return {
      iosUrl: clockNudgeConfig.iosUrl,
      androidUrl: clockNudgeConfig.androidUrl,
    };
  },
  computed: {
    actionWord() {
      return this.mode === "out" ? "Clocking out" : "Clocking in";
    },
    title() {
      return this.mode === "out" ? "Clock out" : "Clock in";
    },
  },
  methods: {
    // Open the store appropriate to the user's device; fall back to the App Store
    // link on desktop/unknown (both links are also shown in the body).
    handleDownload() {
      const ua = (navigator.userAgent || navigator.vendor || "").toLowerCase();
      let url = this.iosUrl;
      if (/android/.test(ua)) {
        url = this.androidUrl;
      } else if (/iphone|ipad|ipod/.test(ua)) {
        url = this.iosUrl;
      }
      window.open(url, "_blank", "noopener");
      // Steer to mobile: don't proceed with the web clock action.
      this.$emit("download");
    },
    handleContinue() {
      this.$emit("continue");
    },
    onDialogVisibility(val) {
      // Closing via the X / backdrop is treated as "do not continue in web".
      if (!val) this.$emit("download");
    },
  },
};
</script>

<style scoped>
.nudge-body {
  text-align: center;
  color: #e0e0e0;
  padding: 4px 6px 0;
}
.nudge-icon {
  font-size: 40px;
  color: #409eff;
  margin-bottom: 12px;
}
.nudge-lead {
  font-size: 16px;
  margin-bottom: 8px;
}
.nudge-sub {
  font-size: 13px;
  color: #b8b8b8;
  margin-bottom: 18px;
}
.nudge-store-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}
.nudge-store-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #79bbff;
  text-decoration: none;
  font-size: 14px;
}
.nudge-store-link:hover {
  text-decoration: underline;
}
.nudge-footer {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: stretch;
}
.nudge-footer .el-button {
  margin-left: 0;
}
</style>
